import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Footer from '@/components/Footer'
import hearder from '@/components/hearder'
import image from '@/components/image/image'
import home from '@/components/home'
import News from '@/components/News/News'
import HomeNews from '@/components/home/HomeNews'
import TranSport from '@/components/transportation/TranSport'
import Facilities from '@/components/Facilities/Facilities'
import PerFormance from '@/components/PerFormance/PerFormance'
import Login from '@/components/Contact/Login'
import Register from '@/components/Contact/Register'
import NewMessage from '@/components/NewMessage/NewMessage'
import Dinnerlist from '@/components/Dinner/Dinnerlist'
import aboutUs from '@/components/aboutUs'
import contactUs from '@/components/contactUs'
import clinical from '@/components/clinical'
import product from '@/components/product'
import solution from '@/components/solution'
import news from '@/components/news'
import newsItem from '@/components/newsItem'
import companyProfile from '@/components/companyProfile'

import HelloWorldEn from '@/components/en/HelloWorld'
import aboutUsEn from '@/components/en/aboutUs'
import clinicalEn from '@/components/en/clinical'
import companyProfileEn from '@/components/en/companyProfile'
import contactUsEn from '@/components/en/contactUs'
import newsEn from '@/components/en/news'
import newsItemEn from '@/components/en/newsItem'
import productEn from '@/components/en/product'


Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,

    },

    {
      path: '/Footer',
      name: 'Footer',
      component: Footer
    },
    {
      path: '/hearder',
      name: 'hearder',
      component: hearder
    },
    // {
    //   path: '/image',
    //   name: 'image',
    //   component: image
    // }, {
    //   path: '/home',
    //   name: 'home',
    //   component: home
    // },
    //
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs
    },
    // {
    //   path: '/clinical',
    //   name: 'clinical',
    //   component: clinical
    //
    // },
    {
      path: '/product',
      name: 'product',
      component: product

    },
    {
      path: '/solution',
      name: 'solution',
      component: solution

    },
    {
      path: '/news2',
      name: 'news',
      component: news

    },
    {
      path: '/newsItem',
      name: 'newsItem',
      component: newsItem

    },
    // {
    //   path: '/companyProfile',
    //   name: 'companyProfile',
    //   component: companyProfile
    //
    // },{
    //   path: '/en',
    //   name: 'HelloWorldEn',
    //   component: HelloWorldEn,
    //
    // },
    // {
    //   path: '/en/aboutUs',
    //   name: 'aboutUsEn',
    //   component: aboutUsEn
    // },
    // {
    //   path: '/en/clinical',
    //   name: 'clinicalEn',
    //   component: clinicalEn
    //
    // },
    // {
    //   path: '/en/companyProfile',
    //   name: 'companyProfileEn',
    //   component: companyProfileEn
    //
    // },
    // {
    //   path: '/en/contactUs',
    //   name: 'contactUsEn',
    //   component: contactUsEn
    // },
    // {
    //   path: '/en/news2',
    //   name: 'newsEn',
    //   component: newsEn
    //
    // },
    // {
    //   path: '/en/newsItem',
    //   name: 'newsItemEn',
    //   component: newsItemEn
    //
    // },
    // {
    //   path: '/en/product',
    //   name: 'productEn',
    //   component: productEn
    //
    // }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js